<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span>CONTENTS</span></p>
<p class="toc-text"><span><a href="#/xhtml/chapter001">Mr Wrong</a></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter002" title="Link target outside of Sample">Summer Picnic</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter003" title="Link target outside of Sample">Pont Du Gard</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">Whip Hand</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">The Proposition</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">The Devoted</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">Child’s Play</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">Toutes Directions</span></span></p>
<p class="toc-text"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">Three Miles Up</span></span></p>
<p class="toc-texts"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?69bac77c